import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiHttpClient } from 'app/http/clients/api';
import { environment } from 'environments/environment';
import { PayrollValidation } from 'app/models/dto/payroll-validation.model';
const baseUrl = `${environment.API_URL}/ppp-validation`;
const allowableVarianceUrl = `${environment.API_URL}/allowable-variance/`;

@Injectable({
  providedIn: 'root'
})
export class PayrollValidationService {

  constructor(private http: ApiHttpClient) { }
  get(borrowerId: number): Observable<PayrollValidation> {
    return this.http.get<PayrollValidation>(`${baseUrl}/${borrowerId}`);
  }

  create(pppValidationDocuments: any): Observable<PayrollValidation> {
    return this.http.post<PayrollValidation>(`${baseUrl}`, pppValidationDocuments);
  }
}
